import { createContext } from 'react'

const BoardingWizardContext = createContext()
export default BoardingWizardContext
